import React from 'react'

// const msg = [
//   'Fetching the latest & greatest ⚡',
//   'Casting internet spells 💫',
//   'Initiating user patience test',
//   'My other loading screen is much faster 🚀',
//   'Fingers crossed 🤞',
//   'Spawning unicorns 🦄',
//   'Copying cats, please wait 🐱',
//   'Still faster than a Windows update 🙃',
//   'Insert elevator_music.mp3'
// ];

class Loader extends React.PureComponent {

  render() {
    // const rndmNum = Math.floor(Math.random() * 9);
    // const msgShown = msg[rndmNum];
    return (
      <div className="loader-wrapper">
        <div className="spinner">
          <div className="cube1"></div>
          <div className="cube2"></div>
        </div>
        <h1>Loading</h1>
        <style jsx>{`
          .loader-wrapper {
            height: calc(100vh - 88px);
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }

          .spinner {
            margin: 100px auto;
            width: 40px;
            height: 40px;
            position: relative;
          }
          
          .cube1, .cube2 {
            background-color: #333;
            width: 15px;
            height: 15px;
            position: absolute;
            top: 0;
            left: 0;
            
            -webkit-animation: sk-cubemove 1.8s infinite ease-in-out;
            animation: sk-cubemove 1.8s infinite ease-in-out;
          }
          
          .cube2 {
            -webkit-animation-delay: -0.9s;
            animation-delay: -0.9s;
          }
          
          @-webkit-keyframes sk-cubemove {
            25% { -webkit-transform: translateX(42px) rotate(-90deg) scale(0.5) }
            50% { -webkit-transform: translateX(42px) translateY(42px) rotate(-180deg) }
            75% { -webkit-transform: translateX(0px) translateY(42px) rotate(-270deg) scale(0.5) }
            100% { -webkit-transform: rotate(-360deg) }
          }
          
          @keyframes sk-cubemove {
            25% { 
              transform: translateX(42px) rotate(-90deg) scale(0.5);
              -webkit-transform: translateX(42px) rotate(-90deg) scale(0.5);
            } 50% { 
              transform: translateX(42px) translateY(42px) rotate(-179deg);
              -webkit-transform: translateX(42px) translateY(42px) rotate(-179deg);
            } 50.1% { 
              transform: translateX(42px) translateY(42px) rotate(-180deg);
              -webkit-transform: translateX(42px) translateY(42px) rotate(-180deg);
            } 75% { 
              transform: translateX(0px) translateY(42px) rotate(-270deg) scale(0.5);
              -webkit-transform: translateX(0px) translateY(42px) rotate(-270deg) scale(0.5);
            } 100% { 
              transform: rotate(-360deg);
              -webkit-transform: rotate(-360deg);
            }
          }

          h1 {
            font-size: 14px;
            font-weight: 200;
            margin-top: 16px;
            opacity: 0;
            animation: pulse 2s ease infinite;
            animation-delay: .8s;
          }

          @media screen and (min-width: 548px) {
            .loader-wrapper {
              height: calc(100vh - 48px);
            }
          }
        `}</style>
      </div>
    )
  }
}

export default Loader


// WEBPACK FOOTER //
// ./src/components/loader/index.js